<template>
  <div>
    <label class="text-uppercase text-muted font-weight-bold small">RTB Publisher Integration</label>
    <b-alert show>
      This US-East endpoint supports GZIP requests/responses. If you need HTTPS, additonal locations, or to check latency,
      please contact us for assistance.
    </b-alert>
    <code>
      <b-form-textarea
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        readonly
        class="squared-textarea bg-white" rows="2"
        :value="ENDPOINT_EAST + '/json/publisher/rtb?pubid=' + zone.company_id">
      </b-form-textarea>
    </code>
  </div>
</template>

<script>
  export default {
      name: 'IntegrationRtb',
      data () {
        return {
          ENDPOINT_EAST
        }
      },
      props: {
          zone: { required: true, type: Object }
      }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/Integrations/Rtb.vue